import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.pallette.blue.primary};
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes[4]}px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
`;
